import React from "react";
import { styled } from "@mui/system";

let warnedOnce = false;

const warn = () => {
  if (!warnedOnce) {
    console.warn(
      [
        "Vapor: The HeaderBar component will be removed from `@vapor/react-material` to `@vapor/react-custom`.",
        "",
        "You should change the name of the component from `HeaderBar` to `VaporHeaderBar`",
        "",
        "For more information you may check Vapor Custom CHANGELOG https://biosphere.teamsystem.com/vapor/react/vapor-custom/-/blob/main/CHANGELOG.md."
      ].join("\n")
    );
  }

  warnedOnce = true;
};

export const HeaderBar = styled(
  (props: any) => {
    warn();
    return null;
  },
  {
    name: "HeaderBar",
    slot: "Root",
    overridesResolver: (props, styles) => []
  }
)(({ theme }) => ({}));
